export default __webpack_public_path__ + "static/media/24.890478cf.png";